import { postRequest } from '@/core';
import { tripTemplates } from '@/requests';

export default async function newTripTemplateRequest(tripTemplate) {
	let url = tripTemplates.getPath();
	let response = await postRequest(url, {}, tripTemplate);
	return response;
}